export const columnWidth = {
    item: 180,
    date: 100,
    dueDate: 80,
    amountDue: 90,
    billCurrency: 80,
    paymentAmount: 108,
    paymentDetails: 200,
    paymentReference: 200,
    attachments: 50,
    overflowMenu: 30,
};
